module.exports = __webpack_public_path__ + "static/s-exam6-09923806222b52c381cb6cac659835de.png";